import React from 'react';
import withRipple from 'jd-library/withRipple';

const AddEditButton = props => {
	return (
		<div
			className={(props.isEdit ? "edit " : "") + " price-button " + " " + ((props.isEdit && !props.customText) ? "edit-price " : "") + props.rippleClass}
			onClick={props.onClick}
			{...props.rippleHandler}
			tabIndex={0}
			role="button"
			aria-label={props.customText || (props.isEdit ? "Edit Price" : "Add Price")}
			onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); e.preventDefault(); props.onClick && props.onClick(e); } }}
		>
			<div className="price-button-content">
				<i
					className={
						props.isEdit
							? "icon-editItem" + " add-edit-icon"
							: "icon-plus" + " add-edit-icon"
					}
				/>
				<span 
					className="price-button-text"
				>
					{props.customText ? props.customText : (
						props.isEdit ? "EDIT PRICE" : "ADD PRICE"
					)}
				</span>
				{props.renderRipple()}
			</div>
		</div>
	);
};

export default withRipple(AddEditButton);
